import React, { useState } from 'react';
import { Box, IconButton, Typography } from '@mui/material';
import { AiOutlineLeft, AiOutlineRight } from "react-icons/ai";
import PropTypes from 'prop-types';
import styles from "./PaginationTable.module.css";

const PaginationTable = ({ 
    data, 
    columns, 
    component: Component, 
    itemsPerPage = 10, 
    onPageChange, 
    onSortChange,
    sortColumn,
    sortOrder
}) => {
    const [currentPage, setCurrentPage] = useState(1);

    const totalPages = Math.ceil(data.length / itemsPerPage);

    const handleSort = (column) => {
        let newOrder = "asc";
        
        if (sortColumn === column.key) {
            if (sortOrder === "asc") newOrder = "desc";
            else if (sortOrder === "desc") newOrder = null; // This will trigger 'none'
            else newOrder = "asc";
        }
    
        onSortChange(column.key, newOrder);
    };

    const handlePageChange = (newPage) => {
        if (newPage >= 1 && newPage <= totalPages) {
            setCurrentPage(newPage);
            onPageChange(newPage, sortColumn, sortOrder);
        }
    };

    // const currentData = data.slice(
    //     (currentPage - 1) * itemsPerPage,
    //     currentPage * itemsPerPage
    // );

    let sortedData = [...data];
    if (sortColumn && sortOrder) {
    sortedData.sort((a, b) => {
        if (a[sortColumn] < b[sortColumn]) return sortOrder === "asc" ? -1 : 1;
        if (a[sortColumn] > b[sortColumn]) return sortOrder === "asc" ? 1 : -1;
        return 0;
    });
    }

    const currentData = sortedData.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
    );

    return (
        <Box className={styles.paginationTable}>
            <Box className={styles.header}>
                {columns.map((col, index) => (
                    <Box
                        key={index}
                        className={styles.columnHeader}
                        style={{ width: col.width }}
                        onClick={() => handleSort(col)}
                    >
                        <span>{col.label}</span>
                        {sortColumn === col.key && (
                            <span className={styles.sortArrow}>
                                {sortOrder === "asc" ? "↑" : "↓"}
                            </span>
                        )}
                        {sortColumn !== col.key && (
                            <span className={styles.sortArrow}>
                                ↑↓
                            </span>
                        )}
                    </Box>
                ))}
            </Box>

            
            <Box className={styles.content}>
                {currentData.map((item, index) => (
                    <Component key={index} {...item} />
                ))}
            </Box>

            {data.length > 0 && (
                <Box className={styles.pagination}>
                    <IconButton onClick={() => handlePageChange(currentPage - 1)} disabled={currentPage === 1}>
                        <AiOutlineLeft />
                    </IconButton>

                    {Array.from({ length: totalPages }, (_, index) => (
                        <button
                            key={index + 1}
                            className={`${styles.pageButton} ${currentPage === index + 1 ? styles.active : ''}`}
                            onClick={() => handlePageChange(index + 1)}
                        >
                            {index + 1}
                        </button>
                    ))}

                    <IconButton onClick={() => handlePageChange(currentPage + 1)} disabled={currentPage === totalPages}>
                        <AiOutlineRight />
                    </IconButton>
                </Box>
            )}
        </Box>
    );
};

PaginationTable.propTypes = {
    data: PropTypes.array.isRequired,
    columns: PropTypes.array.isRequired,
    component: PropTypes.elementType.isRequired,
    itemsPerPage: PropTypes.number,
    onPageChange: PropTypes.func.isRequired,
    onSortChange: PropTypes.func.isRequired,
};

export default PaginationTable;